/**
 * Used by Criteo to track convertions
 *
 * https://gocardless.atlassian.net/browse/SPK-1306
 * Criteo's Segment app requires an orderId and a list of products in order to track
 * a completed transaction.
 *
 * Applied to all the "Merchant Onboarding - Bank Accounts: Step completed" events:
 *
 * apps/merchant-dashboard/src/components/routes/Setup/bank-details-select/LaunchForm.tsx
 * apps/merchant-dashboard/src/components/routes/Setup/bank-details/index.tsx
 * apps/merchant-dashboard/src/components/routes/Intro/add-bank-account/ManualAddBank.tsx
 */
export const criteoProperties = {
  orderId: Math.floor(Math.random() * 1000000000).toString(),
  products: [
    {
      productId: "1",
      price: "0.00",
      quantity: 1,
    },
  ],
};
